<template>
    <tip-tap-editor v-model="html" :simple="true"></tip-tap-editor>
</template>
<style lang="scss" scoped>
    .form-control {
        min-height: 2.5rem;
    }
    /* required class */
    .prism_editor {
        background: #ffff;
        color: black;
        height: 100%;
        width: 100%;
        margin-top: 5px;
        /* you must provide font-family font-size line-height. Example: */
        font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
        font-size: 24px;
        line-height: 1;
        padding: 5px;
    }
    </style>
<script>
import TipTapEditor from "@/components/tiptap/TipTapEditor";
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-css';
import 'prismjs/themes/prism.css';

export default {
    name: "HtmlEditor",
    components: {
        PrismEditor,
        TipTapEditor

    },
    data: () => ({
        html: "",
    }),
    props: ['value'],
    watch: {
        html() {
            this.value = this.html;
            this.$emit('input', this.html);
        }
    },
    methods: {
        highlighter(code) {
            return highlight(code, languages.html, 'html');
        },
    },
    created() {
        this.html = this.value;
    }
}
</script>

